var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    viewBox: "0 0 96 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5308 29.7638C77.1751 29.7638 76.806 29.6454 76.5029 29.4049C75.7946 28.8349 75.6794 27.8006 76.246 27.089L82.0112 19.8813L76.246 12.6771C75.6794 11.9688 75.7946 10.9311 76.5029 10.3612C77.2111 9.79121 78.2456 9.90985 78.819 10.6181L85.4076 18.8535C85.8885 19.4565 85.8885 20.3095 85.4076 20.9125L78.819 29.1479C78.4928 29.5531 78.0117 29.7638 77.5308 29.7638Z",
    fill: "#90BFCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6439 33.3183C51.2518 33.3183 50.8533 33.18 50.5435 32.8935C49.8683 32.2806 49.8122 31.2431 50.4283 30.5644C57.2014 23.0735 67.8454 18.2344 77.5341 18.2344H84.1228C85.0288 18.2344 85.7699 18.9722 85.7699 19.8813C85.7699 20.7906 85.0288 21.5284 84.1228 21.5284H77.5341C68.7316 21.5284 59.0496 25.9428 52.8661 32.7781C52.5399 33.1338 52.0918 33.3183 51.6439 33.3183Z",
    fill: "#90BFCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7459 57.7646C10.8366 57.7646 10.0986 57.0234 10.0986 56.1175C10.0986 55.2116 10.8366 54.4704 11.7459 54.4704C21.4017 54.4704 34.2397 49.2854 39.7807 43.145C40.3902 42.4631 41.4313 42.4137 42.1065 43.0231C42.782 43.6358 42.8346 44.6702 42.2252 45.3522C36.0516 52.2006 22.3768 57.7646 11.7459 57.7646Z",
    fill: "#90BFCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5308 66C77.1751 66 76.806 65.8814 76.5029 65.641C75.7946 65.0743 75.6794 64.0399 76.246 63.3251L82.0112 56.1175L76.246 48.9098C75.6794 48.2015 75.7946 47.1671 76.5029 46.5939C77.2111 46.0274 78.2456 46.1393 78.819 46.8508L85.4076 55.0863C85.8885 55.6925 85.8885 56.5424 85.4076 57.1452L78.819 65.3806C78.4928 65.7892 78.0117 66 77.5308 66Z",
    fill: "#90BFCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1196 57.7646H77.4287C63.6617 57.7646 53.3735 48.3398 43.4246 39.2149C33.502 30.1198 24.1328 21.5284 11.6473 21.5284C10.738 21.5284 10 20.7906 10 19.8813C10 18.9722 10.738 18.2344 11.6473 18.2344C25.4142 18.2344 35.7025 27.6656 45.6514 36.7838C55.574 45.8824 64.9432 54.4703 77.4287 54.4703H84.1196C85.0289 54.4703 85.7667 55.2116 85.7667 56.1175C85.7667 57.0233 85.0289 57.7646 84.1196 57.7646Z",
    fill: "#90BFCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33_128",
    x: 0,
    y: 0,
    width: 95.77,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.74902 0 0 0 0 0.796078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33_128",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.d44988d26e512c6174a06bcc8d8047c7.svg";
export { ForwardRef as ReactComponent };